enum WishlistUpdateType {
	ADD_PRODUCT = 0,
	REMOVE_PRODUCT = 1,
}

export default WishlistUpdateType;
